<template>
    <div>
        <div
                class="date-editor"
                ref="dateEditor"
                @click.stop="toggleVisible">
      <span v-show="!(showStart || showEnd)" style="width: 135px">
        All
      </span>
            <div v-show="showStart || showEnd" class="f-c-c">
        <span
                class="date-text"
                :class="showStart ? '' : 'default'"
        >
          {{showStart || 'All'}}
        </span>
                <span>~</span>
                <span
                        class="date-text"
                        :class="showEnd ? '' : 'default'"
                >
          {{showEnd || 'All'}}
        </span>
            </div>
            <i
                    :class="visible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
            </i>
        </div>
        <transition
                name="el-fade-in-linear"
        >
            <div
                    v-show="visible"
                    class="date-content"
                    @click.stop
                    :style="{
          top: `${top}px`,
          left: `${left}px`
        }"
            >
                <div class="picker-item" key="clear" @click="clear">All</div>
                <div
                        v-for="(item, key) in timeOptions"
                        :key="key"
                        @click="quickCheck(item.value)"
                        class="picker-item"
                >
                    {{item.name}}
                </div>
                <div class="picker-content">
                    <div class="pdrl-10">Select by yourself</div>
                    <div class="picker-cell">
                        <div class="mb-10 pdrl-10">
                            <span style="width: 36px;display: inline-block;">From </span>
                            <el-date-picker
                                    v-model="start"
                                    :picker-options="startPickerOptions"
                                    type="date"
                                    size="mini"
                                    ref="startDate"
                                    value-format="yyyy-MM-dd"
                                    class="date-picker"
                                    :popper-append-to-body="false"
                                    :placeholder="startPlaceholder">
                            </el-date-picker>
                        </div>
                        <div class="pdrl-10">
                            <span style="width: 36px;display: inline-block;">To </span>
                            <el-date-picker
                                    v-model="end"
                                    :picker-options="endPickerOptions"
                                    size="mini"
                                    ref="endDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    class="date-picker"
                                    :placeholder="endPlaceholder">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="pd-10">
                    <el-button
                            @click="save"
                            type="primary"
                            size="mini">SAVE
                    </el-button>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'DateRange',
  props: {
    value: {
      type: Array,
      default: () => ['', '']
    },
    startPlaceholder: {
      type: String,
      default: 'Start time'
    },
    endPlaceholder: {
      type: String,
      default: 'End time'
    },
    timeOptions: {
      type: Array,
      default: () => {
        return [{
          name: 'In a week',
          value: 7
        }, {
          name: 'In a month',
          value: moment().diff(moment().month(moment().month() - 1).format('YYYY-MM-DD'), 'days')
        }, {
          name: 'In a year',
          value: moment().diff(moment().year(moment().year() - 1).format('YYYY-MM-DD'), 'days')
        }]
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val.length === 2) {
          this.showStart = this.start = val[0]
          this.showEnd = this.end = val[1]
        }
      }
    }
  },
  computed: {
    startPickerOptions ({end}) {
      return {
        disabledDate (time) {
          return end ? time.getTime() > new Date(end).getTime() : false
        }
      }
    },
    endPickerOptions ({start}) {
      return {
        disabledDate (time) {
          return start ? time.getTime() < new Date(start).getTime() : false
        }
      }
    }
  },
  data () {
    return {
      showStart: '',
      showEnd: '',
      start: '',
      end: '',
      visible: false,
      top: 0,
      left: 0
    }
  },
  mounted () {
    window.addEventListener('resize', this.hide)
    document.body.addEventListener('click', this.hide)
  },
  methods: {
    save () {
      const value = [this.start, this.end]
      this.$emit('update:value', value)
      this.$emit('change')
      this.hide()
    },
    quickCheck (days = 1) {
      this.start = this.$moment().subtract('days', days).format('YYYY-MM-DD')
      this.end = this.$moment().format('YYYY-MM-DD')
      this.save()
    },
    clear () {
      this.start = ''
      this.end = ''
      this.save()
    },
    toggleVisible (e) {
      this.visible = !this.visible
      if (this.visible) {
        const dom = this.$refs['dateEditor']
        const msg = dom.getBoundingClientRect()
        this.top = msg.top + dom.offsetHeight + 8
        this.left = msg.left
        this.start = this.showStart
        this.end = this.showEnd
      }
    },
    hide () {
      this.visible = false
      this.$refs.startDate.handleClose()
      this.$refs.endDate.handleClose()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.hide)
    document.body.removeEventListener('click', this.hide)
  }
}
</script>
<style lang="less" scoped>
    .mb-10 {
        margin-bottom: 10px;
    }

    .pd-10 {
        padding: 10px;
    }

    .pdrl-10 {
        padding: 0 10px;
    }

    .f-c-c {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .date-editor {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        // width: 210px;
        height: 32px;
        background: #fff;
        padding: 5px 5px 5px 6px;
        border: 1px solid #DCDFE6;
        cursor: pointer;

        .date-text {
            display: inline-block;
            width: 77px;
            white-space: nowrap;

            &.default {
                color: #ccc;
                text-align: center;
            }
        }
    }

    .date-content {
        position: fixed;
        z-index: 900;
        padding-top: 5px;
        background: #fff;
        border: 1px solid #e4e4e4;
    }

    .picker-content {
        margin-top: 5px;
        padding: 5px 0 0;
        border-top: 1px solid #E4E7ED;

        .picker-cell {
            padding: 10px 0;
            margin-top: 5px;
            background: #f2f6fc;

            /deep/ .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .picker-item {
        padding: 4px 10px;
        cursor: pointer;
    }

    .date-picker {
        width: 130px !important
    }
</style>
